import getLetterByIndex from 'utils/getLetterByIndex';
import numbering from 'sharedParts/utils/numbering';
import personalLabelMap from 'sharedParts/config/personalLabelMap';

const { alphabet, number, numberDesc } = personalLabelMap;

const getSubLabelByType = ({ labelType, index, startFromZero }) => {
  switch (labelType) {
    case number:
    case numberDesc:
      return String(startFromZero ? index : numbering.toHuman(index));
    case alphabet:
      return getLetterByIndex(index);
    default:
      return null;
  }
};

export default getSubLabelByType;
